import React from "react";
import {useTranslation} from "react-i18next";
import LeadDashboardLayout from "./Layout/LeadDashboardLayout.jsx";
import ChannelGrid from "../MarketingChannelGrids/ChannelGrid.jsx";
import {GridType} from "../MarketingChannelGrids/channelGridColumnSetup.js";


export default function LeadMarketingChannelOverview({project}) {

    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <LeadDashboardLayout title={t('route.campaign-overview')}>
        <ChannelGrid project={project} gridType={GridType.MarketingLeads}/>
    </LeadDashboardLayout>;
}
